import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { PublicCreateActionContext } from "./PublicCreateActionContext";

function useStore() {
  const { element, setBackendFormErrors } = useContext(PublicCreateActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    store("invoices/public", element)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        console.error("Error fetching data:", error);
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useStore;
